export const SET_PLAYER_GAMES = 'SET_PLAYER_GAMES';
export const SET_PLAYER = 'SET_PLAYER';
export const SET_PLAYERS_LIST = 'SET_PLAYERS_LIST';
export const PLAYER_SENDING_REQUEST = 'PLAYER_SENDING_REQUEST';
export const PALYER_SENDING_REQUEST_FAILURE = 'PALYER_SENDING_REQUEST_FAILURE';
export const SET_SELECTED_PLAYER = 'SET_SELECTED_PLAYER';
export const RELEASE_SELECTED_PLAYER = 'RELEASE_SELECTED_PLAYER';
